import { Field, Int, ArgsType } from '@nestjs/graphql'

@ArgsType()
export class UserAnalysisArgs {
  @Field(t => Int)
  userId!: number

  @Field({ nullable: true })
  teamOnly?: boolean

  @Field(t => Int, { nullable: true })
  teamId?: number

  @Field({ nullable: true })
  includeCancelled?: boolean

  @Field({ nullable: true })
  includeReviews?: boolean

  @Field(t => Int, { nullable: true })
  skip?: number

  @Field(t => Int, { nullable: true })
  take?: number
}
